import { render, staticRenderFns } from "./EvenementForm.vue?vue&type=template&id=764a62d1&scoped=true&"
import script from "./EvenementForm.vue?vue&type=script&lang=js&"
export * from "./EvenementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764a62d1",
  null
  
)

export default component.exports